import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';


@Injectable()
export class RequestService {

  constructor() {

  }

  public buildHttpHeaders(type?: string): HttpHeaders {
    const doctype = !!type ? type : 'application/json';
    return new HttpHeaders()
      .set('Content-Type', doctype)
      .set('Accept', doctype);
  }
}
